import React from 'react';
import { XIcon } from 'lucide-react';
const problems = [{
  title: 'Inflamación Facial y Corporal',
  desc: 'Te despiertas con los párpados hinchados y sientes pesadez en todo el cuerpo.'
}, {
  title: 'Agotamiento de "Batería Baja"',
  desc: 'Sientes que necesitas una siesta apenas terminas de desayunar.'
}, {
  title: 'Bloqueo de Peso',
  desc: 'No importa cuánto dejes de comer, la báscula no se mueve o incluso sube.'
}, {
  title: 'Neblina Mental',
  desc: 'Te cuesta concentrarte en tus clases, trabajo o tareas diarias y olvidas las cosas fácilmente.'
}];
export function PainSection() {
  return <section className="py-8 px-4 bg-brand-cream" data-id="element-84">
      <div className="max-w-xl mx-auto" data-id="element-85">
        <h2 className="text-xl sm:text-2xl font-heading font-bold text-center mb-4 text-brand-forest leading-tight" data-id="element-86">
          El problema no es tu falta de voluntad, es que tu metabolismo está
          bajo un "incendio" inflamatorio.
        </h2>

        <p className="text-sm sm:text-base text-center text-brand-text mb-6 leading-relaxed" data-id="element-87">
          Muchas mujeres viven resignadas a la fatiga, la caída del cabello y la
          ropa apretada porque creen que es "parte de su condición". Pero la
          verdad es que mientras sigas consumiendo ingredientes que irritan tu
          tiroides, ninguna dosis de medicamento será suficiente. Tu cuerpo no
          necesita más químicos; necesita el combustible correcto para dejar de
          atacarse a sí mismo.
        </p>

        <p className="text-center text-sm sm:text-base font-bold text-brand-forest mb-4" data-id="element-88">
          ¿Sufres de alguno de estos problemas urgentes?
        </p>

        <div className="space-y-3" data-id="element-89">
          {problems.map((p, i) => <div key={i} className="flex gap-3 items-start bg-white p-4 rounded-lg border border-brand-border" data-id="element-90">
              <div className="mt-0.5 bg-red-50 p-1.5 rounded shrink-0" data-id="element-91">
                <XIcon className="w-4 h-4 text-red-600" strokeWidth={2.5} data-id="element-92" />
              </div>
              <div data-id="element-93">
                <p className="text-sm sm:text-base font-bold text-brand-forest leading-snug" data-id="element-94">
                  {p.title}
                </p>
                <p className="text-xs sm:text-sm text-brand-muted leading-snug mt-1" data-id="element-95">
                  {p.desc}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}